export default {
    showLoader() {
        $('.js-global-loader').show();
        $('body').addClass('has-global-loader');
    },
    hideLoader() {
        $('.js-global-loader').hide();
        $('body').removeClass('has-global-loader');
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/global-loader.js